<template>
  <div class="bb-date-filter">
    <transition name="fade">
      <div class="bb-date-filter__date"
           :class="{
             'bb-date-filter__date_right': position === 'right',
             'bb-date-filter__date_border': border
           }"
           v-if="visibleRange">
        <DataPicker @setDate="setInterval"
                    font-size="14"
                    :default-date="defaultRangeDate"
                    :no-border="true"
                    :range="'range'"/>
      </div>
    </transition>
    <div class="bb-date-filter__select">
      <custom-select :list="dateRangeList"
                     fontSize="12"
                     :default-val="dateRangeList[7]"
                     @setValue="setDefaultInterval"/>
    </div>
  </div>
</template>

<script>
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import moment from 'moment'

export default {
  name: 'FilterByDate',
  props: ['getQuery', 'position', 'allName', 'border', 'future'],
  components: {
    CustomSelect,
    DataPicker
  },
  data () {
    return {
      visibleRange: false,
      format: 'YYYY-MM-DD',
      selectedDate: {
        end: false,
        start: false
      }
    }
  },
  computed: {
    dateRangeList () {
      return [
        {
          name: `${this.future ? 'Next' : 'Last'} 7 days`,
          id: 1
        },
        {
          name: 'Current month',
          id: 2
        },
        {
          name: `${this.future ? 'Next' : 'Last'} month`,
          id: 3
        },
        {
          name: `${this.future ? 'Next' : 'Last'} 3 months`,
          id: 4
        },
        {
          name: `${this.future ? 'Next' : 'Last'} 6 months`,
          id: 5
        },
        {
          name: `${this.future ? 'Next' : 'Last'} 12 months`,
          id: 6
        },
        {
          name: 'Custom date',
          id: 7
        },
        {
          name: this.allName || 'All Entries',
          id: 8
        }
      ]
    },
    defaultRangeDate () {
      const start = this.selectedDate.start || moment().subtract(6, 'days')
      const end = this.selectedDate.end || moment()
      return {
        start: start,
        end: end
      }
    }
  },
  methods: {
    setDefaultInterval (item) {
      const id = item.id
      let start = moment()
      let end = moment()
      switch (id) {
      case 1:
        this.future ? end.add(6, 'days') : start.subtract(6, 'days')
        break
      case 2:
        start.startOf('month')
        end.endOf('month')
        break
      case 3:
        this.future ? start.add(1, 'month') : start.subtract(1, 'month')
        start.startOf('month')
        this.future ? end.add(1, 'month') : end.subtract(1, 'month')
        end.endOf('month')
        break
      case 4:
        this.future ? end.add(3, 'month') : start.subtract(3, 'month')
        start.startOf('month')
        this.future ? start.add(1, 'month') : end.subtract(1, 'month')
        end.endOf('month')
        break
      case 5:
        this.future ? end.add(6, 'month') : start.subtract(6, 'month')
        start.startOf('month')
        this.future ? start.add(1, 'month') : end.subtract(1, 'month')
        end.endOf('month')
        break
      case 6:
        this.future ? end.add(12, 'month') : start.startOf('year')
        break
      case 8:
        this.future ? start.add(10, 'years') : start.subtract(10, 'years')
        this.future ? end.subtract(10, 'years') : end.add(10, 'years')
        break
      case 7:
        this.visibleRange = true
        return
      }
      this.visibleRange = false
      const isAfter = start.isAfter(end)
      const startFormat = start.format('YYYY-MM-DD')
      const endFormat = end.format('YYYY-MM-DD')
      const filter = isAfter ? `${endFormat};;${startFormat}` : `${startFormat};;${endFormat}`
      this.selectedDate.end = endFormat
      this.selectedDate.start = startFormat
      this.$emit('setDate', filter)
      if (typeof this.getQuery !== 'function') return
      this.getQuery({filter})
    },
    setInterval (date) {
      if (!date) return
      const start = moment(date.start).format(this.format)
      const end = moment(date.end).format(this.format)
      const filter = `${start};;${end}`
      this.selectedDate.end = end
      this.selectedDate.start = start
      this.$emit('setDate', filter)
      if (typeof this.getQuery !== 'function') return
      this.getQuery({filter})
    }
  },
  watch: {
    getQuery () {
      if (!this.selectedDate.start || !this.selectedDate.end) return
      const filter = `${this.selectedDate.start};;${this.selectedDate.end}`
      if (typeof this.getQuery !== 'function') return
      this.getQuery({filter: filter})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-date-filter {
    position: relative;
    display: flex;
    z-index: 25;
    height: 42px;

    &__select {
      min-width: 163px;
    }

    &__date {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1px 0 10px;
      margin-right: 12px;
      background-color: $color-white;
      border-radius: 5px;
      height: 42px;

      &_right {
        order: 2;
        margin-right: 0;
        margin-left: 12px;
      }

      &_border {
        padding: 0;
        border: 1px solid $color-wild-sand;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/FilterByDate/FilterByDate.vue